export default __webpack_public_path__ + "static/media/people.83eee51f.svg";